import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { MenuBtnComponent } from './menu-btn/menu-btn.component';
import { FiltersComponent } from './filters/filters.component';
import { SiteConfiguration } from '../../../configuration/configuration';

@Component({
  selector: 'app-menu',
  imports: [MenuBtnComponent, FiltersComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent {
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  public isOpen: boolean = false;
  public filtersData: any = SiteConfiguration.features.filters.data;

  public toggleMenu() {
    this.isOpen = !this.isOpen;
    this.cdr.markForCheck();
    // console.log('toggle menu', this.isOpen);
  }

  public closeMenu() {
    // console.log('close menu');
    this.isOpen = false;
  }

}
